import { useInfiniteQuery } from "@tanstack/react-query";
import { reactQueryCacheAndRefetchOptions } from "@";
import { getZipFiles } from "../requests/get-zip-files.ts";
import { verifyKeys } from "./keys.ts";
import type { ZipFilesListResponse } from "../../types.ts";

export const ZIP_FILES_PAGE_SIZE = 4;

export const useInfiniteZipFilesQuery = (name: string, enabled: boolean) => {
  return useInfiniteQuery<ZipFilesListResponse>({
    queryKey: verifyKeys.zipFiles(name),
    queryFn: async ({ pageParam }) => {
      const { data } = await getZipFiles(
        pageParam as number,
        ZIP_FILES_PAGE_SIZE,
        name,
      );
      return data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const loaded = allPages.reduce(
        (sum, p) => sum + (p.data?.length ?? 0),
        0,
      );
      return loaded < (lastPage.totalItems ?? 0)
        ? allPages.length + 1
        : undefined;
    },
    enabled,
    ...reactQueryCacheAndRefetchOptions,
  });
};
